import queryString from "query-string";
import { PureComponent } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { asyncState, validNumber } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type StabilizedsandCalculatorState = {
    stabilizedsandLength: number;
    stabilizedsandWidth: number;
    stabilizedsandThickness: number;
    stabilizedsandArea: number;
    stabilizedsandVolume: number;
};

class StabilizedsandCalculator extends PureComponent<
    {},
    StabilizedsandCalculatorState
> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);
        this.state = {
            stabilizedsandLength: this.query.stabilizedsandLength
                ? Number(this.query.stabilizedsandLength)
                : 0,
            stabilizedsandWidth: this.query.stabilizedsandWidth
                ? Number(this.query.stabilizedsandWidth)
                : 0,
            stabilizedsandThickness: this.query.stabilizedsandThickness
                ? Number(this.query.stabilizedsandThickness)
                : 0,
            stabilizedsandArea: 0,
            stabilizedsandVolume: 0
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            stabilizedsandArea: this.stabilizedsandArea(),
            stabilizedsandVolume: this.stabilizedsandVolume()
        });

        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.stabilizedSand);
    }

    stabilizedsandArea = () => {
        const length = this.state.stabilizedsandLength;

        const width = this.state.stabilizedsandWidth;
        const area = Number(length * width);

        return validNumber(area) ? area : 0;
    };
    stabilizedsandVolume = () => {
        const length = this.state.stabilizedsandLength;

        const width = this.state.stabilizedsandWidth;

        const thickness = this.state.stabilizedsandThickness * 0.01; // convert cm to m
        const volume = Number(length * width * thickness);

        return validNumber(volume) ? volume : 0;
    };

    setCalculationValue = (field: string, value: string) => {
        const numberValue = parseFloat(value.replace(",", "."));
        this.setState(
            (state) => ({ ...state, [field]: numberValue }),
            () => {
                this.setState({
                    stabilizedsandArea: this.stabilizedsandArea(),
                    stabilizedsandVolume: this.stabilizedsandVolume()
                });

                CalculatorStepTracker.trackSubmit(
                    CALCULATOR_KEYS.stabilizedSand
                );
            }
        );
    };

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            stabilizedsandLength: this.state.stabilizedsandLength,
            stabilizedsandWidth: this.state.stabilizedsandWidth,
            stabilizedsandThickness: this.state.stabilizedsandThickness
        };
        const resultProps = {
            stabilizedsandArea: this.state.stabilizedsandArea,
            stabilizedsandVolume: this.state.stabilizedsandVolume,
            mailParams: {
                stabilizedsandLength: this.state.stabilizedsandLength,
                stabilizedsandWidth: this.state.stabilizedsandWidth,
                stabilizedsandThickness: this.state.stabilizedsandThickness
            }
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { StabilizedsandCalculator };
